import { jsx as _jsx } from "react/jsx-runtime";
import { Page_BaseManagerUI_SingleType_Proto, Renderer_SearchResult, SearchItemV3_With_ID, SearchSelector_BaseManagerUI } from '@app/styles';
import { TS_HorizontalWorkspace } from '@nu-art/ts-workspace-frontend/index';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import { WorkspaceKey_Permissions } from './workspace.js';
import { ModuleFE_User } from '@app/org-frontend';
import { QPageMessage } from '@app/hcs-frontend';
import { ModuleFE_PermissionUser, RoutePermissions } from '@nu-art/permissions-frontend/index';
import { ModuleFE_PermissionManagerUI } from '../../../modules/ModuleFE_PermissionManagerUI/ModuleFE_PermissionManagerUI.js';
import { EditorWrapper_Accounts } from './editors/EditorWrapper_Accounts.js';
export const searchItemKey_Users = ModuleFE_User.dbDef.dbKey;
export class Manager_Permissions extends Page_BaseManagerUI_SingleType_Proto {
    // ######################## Static ########################
    static Route = {
        key: WorkspaceKey_Permissions,
        path: WorkspaceKey_Permissions,
        Component: this,
        enabled: RoutePermissions(ModuleFE_PermissionManagerUI.permissions.ui.Release),
        modulesToAwait: [ModuleFE_Account, ModuleFE_User, ModuleFE_PermissionUser],
    };
    static SearchableItem_User = SearchItemV3_With_ID({
        module: ModuleFE_User,
        type: searchItemKey_Users,
        route: Manager_Permissions.Route,
        entityName: ModuleFE_User.dbDef.dbKey,
        entityLabel: 'User',
        groupId: ['Administrative'],
        mapper: (item) => {
            const account = ModuleFE_Account.cache.unique(item._id);
            return [account?.email ?? 'Failed to find account'];
        },
        tags: [],
        renderer: (item, selected, onClickCallback) => {
            const account = ModuleFE_Account.cache.unique(item._id);
            const entityLabel = account?.type === 'service' ? 'Service Account' : 'User';
            return _jsx(Renderer_SearchResult, { itemId: item._id, itemKey: searchItemKey_Users, itemLabel: account?.email ?? 'Failed to find account', entityLabel: entityLabel, hierarchy: 'Users', onClickCallback: onClickCallback, selected: selected, style: { textTransform: 'none' } });
        },
        resultRenderer: (item) => {
            const account = ModuleFE_Account.cache.unique(item);
            return _jsx(EditorWrapper_Accounts, { account: account });
        },
        filter: item => ModuleFE_Account.cache.unique(item._id)?.type !== 'service'
    });
    static defaultProps = {
        searchItems: [Manager_Permissions.SearchableItem_User]
    };
    // ######################## Lifecycle ########################
    getInitialObject() {
        return {};
    }
    // ######################## Render ########################
    renderSearch = () => {
        return _jsx(SearchSelector_BaseManagerUI, { onSearchItemSelected: (item) => this.onSearchResultSelected(item.id, item.type), searchItems: [Manager_Permissions.SearchableItem_User], selectedItem: this.state.selectedResult, buttons: [] });
    };
    renderEditor = () => {
        if (!this.state.selectedItem)
            return _jsx(QPageMessage, { message: 'Permissions Editor' });
        const account = ModuleFE_Account.cache.unique(this.state.selectedItem.item._id);
        if (!account)
            throw new MUSTNeverHappenException(`Could not find account with same user id ${this.state.selectedItem.item._id}`);
        return _jsx(EditorWrapper_Accounts, { account: account });
    };
    // ######################## Logic ########################
    workspace = {
        id: WorkspaceKey_Permissions,
        key: WorkspaceKey_Permissions,
        renderers: {
            horizontalSpace: TS_HorizontalWorkspace,
        },
        instances: {
            selector: this.renderSearch.bind(this),
            presenter: this.renderEditor.bind(this),
        }
    };
}
